import React, { useEffect } from "react";
import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import UpcomingExams from "../components/UpcomingExams";
import { useDispatch, useSelector } from "react-redux";
import { fetchtrainingDashboard } from "../redux/slices/dashboardSlice";
import img1 from "../Assets/Images/dcard-image-1.png";
import img2 from "../Assets/Images/dcard-image-2.png";
import img3 from "../Assets/Images/dcard-image-3.png";
import img4 from "../Assets/Images/dcard-image-4.png";
import DashboardDisplayCards from "../components/DashboardDisplayCards";
import DashboardProgrammeReport from "../components/DashboardProgrammeReport";

const TrainingPrgmOfficerDashboard = () => {
  const dispatch = useDispatch();
  const trainingDashboardData = useSelector(
    (state) => state?.dashboard?.trainingDashboard
  );

  useEffect(() => {
    dispatch(fetchtrainingDashboard());
  }, [dispatch]);

  const details = [
    {
      name: "Total Number Of Students",
      number: trainingDashboardData?.memberCategoryCounts?.totalStudent,
      bgcolor: "#FFF6EC",
      icon: img1,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Number Of NYSC Members",
      number: trainingDashboardData?.memberCategoryCounts?.totalNYSC,
      bgcolor: "#FCEAE4",
      icon: img2,
      imgBgColor: "#F8D4C8",
    },
    {
      name: "Total Number Of Graduates",
      number: trainingDashboardData?.memberCategoryCounts?.totalGraduate,
      bgcolor: "#EFE6F6",
      icon: img3,
      imgBgColor: "#E7D1F8",
    },
    {
      name: "Total Number Of Fellows",
      number: trainingDashboardData?.memberCategoryCounts?.totalFellow,
      bgcolor: "#FFECF0",
      icon: img1,
      imgBgColor: "#F4BCCA",
    },
    {
      name: "Total Number Of Associates",
      number: trainingDashboardData?.memberCategoryCounts?.totalAssociate,
      bgcolor: "#EDF2FB",
      icon: img4,
      imgBgColor: "#416EFC4A",
    },
  ];

  return (
    <>
      <Flex
        flexDirection={"column"}
        gap={"20px"}
        py={"30px"}
        // minH={"100vh"}
        px={3}
      >
        <Flex
          flexDirection={["column", "column", "column", "row"]}
          justifyContent={["center", "center", "flex-start"]}
          alignItems={"center"}
          gap={"20px"}
        >
          <Box
            w={["100%", "100%", "100%"]}
            bgColor={"#FFFFFF"}
            borderRadius={"14px"}
            border={"1px solid #E3EBEE"}
            padding={"20px"}
          >
            <Grid
              gridTemplateColumns={[
                "repeat(1, 1fr)",
                "repeat(2, 1fr)",
                "repeat(3, 1fr)",
                "repeat(4, 1fr)",
                "repeat(5, 1fr)",
              ]}
              gap={5}
            >
              {details?.map((detail, index) => (
                <GridItem>
                  <DashboardDisplayCards key={index} {...detail} />
                </GridItem>
              ))}
            </Grid>
          </Box>
        </Flex>
      </Flex>
      <Flex
        // mt={6}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%", "60%", "70%"]}>
              <DashboardProgrammeReport barChartData={trainingDashboardData?.eventReportPerMonth} />
               </Box>
        <Box width={["100%", "100%", "100%", "40%", "30%"]}>
          <UpcomingExams
            upcomingEvents={trainingDashboardData?.upcomingProgrammes}
            title={"Upcoming Programmes"}
          />
        </Box>
      </Flex>
    </>
  );
};

export default TrainingPrgmOfficerDashboard;
